import { TestData } from "./TestData"
import { IDay, ISettingsType, IShip, IShipVesselType, IShipStatus, IStatusType, ITrack, ITrip, INoteType, IShipUserCrewRole, IShipUserLevel, ILogWeather } from "../../app/Types"

const d = (new Date()).toISOString();

export function day(date: Date): number {
  return (date.getTime() - new Date(Date.UTC(2001, 0, 1)).getTime()) / (60 * 60 * 24 * 1000);
}

function parseDuration(timeStr: string): number {
  const parts = timeStr.split(":").map(Number);
  if (parts.length === 3) {
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  } else if (parts.length === 2) {
    return parts[0] * 3600 + parts[1] * 60;
  }
  return 0;
}

export function TestShip(fullData: boolean = true): TestData {
  const ship = {
    id: 1,
    accountId: 1,
    createdAt: d,
    updatedAt: d,
    engineCount: 2,
    name: "Lipoza",
    vesselType: IShipVesselType.sailing,
    shipData: {
      name: "Lipoza",
      engineCount: 2,
      vesselType: IShipVesselType.sailing,
      mmsi: "211234567",
      callsign: "DF1234",
      engines: [
        { id: "1", number: 1, nmeaNumber: 1, engineShortName: "Starboard", name: "Starboard", type: "inboard", fuelType: "diesel" },
        { id: "2", number: 2, nmeaNumber: 2, engineShortName: "Portside", name: "Portside", type: "inboard", fuelType: "diesel" },
      ],
      sails: [
        { id: "mainsail", sail: "mainsail", sailType: "mast", reefNo: 3 },
        { id: "parasailor", sail: "parasailor", sailType: "forestay", reefNo: 0 },
      ],
    },
  } as unknown as IShip;

  const data = {
    account: { id: 1, createdAt: d, updatedAt: d, accountSubscriptionPlanId: 1, name: "Test Account", slug: "test-account", metadata: "{}", subscriptionStatus: 1 },
    cruises: [
      { id: 1, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "", startedAt: undefined, completedAt: undefined, data: "{}" },
    ],
    days: [
      { id: 1, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 1, tripId: 1, data: "{}", day: 0, timezone: 0, startLocation: "", endLocation: "", calculated: { duration: 0, sog: 0, distance: 0, dayStatusButton: "none", dayStatus: "none", nightStatusButton: "none", nightStatus: "none" } },
    ],
    logs: [],
    statuses: [],
    session: { id: "deadbeef", authorized: true, accountId: 1, userId: 1 },
    ship: ship,
    ships: [ship],
    settings: [{
      id: 1,
      accountId: 1,
      shipId: ship.id,
      userId: 0,
      createdAt: d,
      updatedAt: d,
      settingType: ISettingsType.shipData,
      data: JSON.stringify(ship.shipData),
    }],
    shipUsers: [
      { id: 1, accountId: 1, shipId: 1, userId: 1, createdAt: d, updatedAt: d, active: 1, name: "Captain John", shortname: "John", email: "john@example.com", shipUserLevel: IShipUserLevel.primary, shipUserCrewRole: IShipUserCrewRole.skipper, data: "{}" },
      { id: 2, accountId: 1, shipId: 1, createdAt: d, updatedAt: d, active: 1, name: "Sarah Miller", shortname: "Sarah", email: "sarah@example.com", shipUserLevel: IShipUserLevel.editCurrent, shipUserCrewRole: IShipUserCrewRole.crew, data: "{}" },
    ],
    tracks: [] as ITrack[],
    trips: [
      { id: 1, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 1, title: "", timezone: 0, startedAt: undefined, completedAt: undefined, data: "{}" },
    ],
    user: { id: 1, createdAt: d, updatedAt: d, authenticationType: 0, name: "DemoUser", email: "testuser@example.com", shortname: "DemoUser" },
  };

  if (fullData) {
    return Object.assign(data, {
      cruises: [
        { id: 1, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "Mediterranean Sea 1", startedAt: new Date(Date.UTC(2023, 5, 9)).toISOString(), completedAt: new Date(Date.UTC(2023, 5, 9)).toISOString(), data: "{}" },
        { id: 2, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "Mediterranean Sea 2", startedAt: new Date(Date.UTC(2023, 7, 12)).toISOString(), completedAt: new Date(Date.UTC(2023, 9, 5)).toISOString(), data: "{}" },
        { id: 3, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "To Canary Islands", startedAt: new Date(Date.UTC(2023, 9, 9)).toISOString(), completedAt: new Date(Date.UTC(2023, 11, 7)).toISOString(), data: "{}" },
        { id: 4, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "Canary Islands 2024 - 1", startedAt: new Date(Date.UTC(2024, 0, 9)).toISOString(), completedAt: new Date(Date.UTC(2024, 1, 13)).toISOString(), data: "{}" },
        { id: 5, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "Canary Islands 2024 - 2", startedAt: new Date(Date.UTC(2024, 2, 27)).toISOString(), completedAt: new Date(Date.UTC(2024, 3, 25)).toISOString(), data: "{}" },
        { id: 6, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "Canary Islands 2024 - 3", startedAt: new Date(Date.UTC(2024, 7, 9)).toISOString(), completedAt: new Date(Date.UTC(2024, 8, 25)).toISOString(), data: "{}" },
        { id: 7, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "Canary Islands 2025", startedAt: new Date(Date.UTC(2025, 1, 18)).toISOString(), completedAt: new Date(Date.UTC(2025, 4, 20)).toISOString(), data: "{}" },
        { id: 8, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "Back to Mediterranean Sea", startedAt: new Date(Date.UTC(2025, 4, 29)).toISOString(), completedAt: new Date(Date.UTC(2025, 5, 19)).toISOString(), data: "{}" },

        // used for timeline and day view in demo
        { id: 9,
          createdAt: d,
          updatedAt: d,
          accountId: 1,
          shipId: 1,
          title: "Mediterranean Sea",
          startedAt: new Date(Date.UTC(2025, 5, 24)).toISOString(),
          completedAt: new Date(Date.UTC(2025, 9, 16)).toISOString(),
          data: "{}",
          calculated: {
            distance: 1186,
            distanceUnderEngine: 148,
            distanceUnderSails: 1038,
            duration: parseDuration("634:18"),
            durationCruising: parseDuration("509:56"),
            durationPaused: parseDuration("124:22"),
            durationUnderEngine: parseDuration("149:38"),
            durationUnderSails: parseDuration("634:19"),
            engines: [
              { number: 1, distance: 109.4, duration: parseDuration("131:34") },
              { number: 2, distance: 111.8, duration: parseDuration("634:19") },
            ],
            sog: 2.33,

          },
        },

        { id: 10, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "To Canary Islands", startedAt: new Date(Date.UTC(2025, 9, 17)).toISOString(), completedAt: new Date(Date.UTC(2025, 9, 23)).toISOString(), data: "{}" },
        { id: 11, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "To Cap Verdes", startedAt: new Date(Date.UTC(2025, 10, 25)).toISOString(), completedAt: new Date(Date.UTC(2025, 11, 8)).toISOString(), data: "{}" },
        { id: 12, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "To Caribbean", startedAt: new Date(Date.UTC(2025, 11, 9)).toISOString(), completedAt: new Date(Date.UTC(2025, 11, 21)).toISOString(), data: "{}" },
        { id: 13, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "Caribbean", startedAt: new Date(Date.UTC(2025, 11, 22)).toISOString(), completedAt: new Date(Date.UTC(2025, 11, 31)).toISOString(), data: "{}" },
        { id: 14, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, title: "Caribbean 2026", startedAt: new Date(Date.UTC(2026, 0, 1)).toISOString(), data: "{}" },
      ],

      days: [
        // this are the days for the trip used in the timeline and day view demo
        { id: 1, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, data: "{}", day: day(new Date(Date.UTC(2025, 5, 24))), timezone: 2, comment: "Start of the passage to Ibiza", startLocation: "Malaga", endLocation: "Playa la Caletta", calculated: { duration: parseDuration("1:02"), sog: 0.5, distance: 0.5 } },
        { id: 2, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, data: "{}", day: day(new Date(Date.UTC(2025, 5, 25))), timezone: 2, startLocation: "Playa la Caletta", endLocation: "Cala de Canuela", calculated: { duration: parseDuration("19:44"), sog: 0.9, distance: 17.6 } },
        { id: 3, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, data: "{}", day: day(new Date(Date.UTC(2025, 5, 26))), timezone: 2, startLocation: "Cala de Canuela", endLocation: "Ensenada de San Miguel", calculated: { duration: parseDuration("9:53"), sog: 2.8, distance: 27.5 } },

        // this day is used for the day view demo
        { id: 6,
          createdAt: d,
          updatedAt: d,
          accountId: 1,
          shipId: 1,
          cruiseId: 9,
          tripId: 1,
          day: day(new Date(Date.UTC(2025, 5, 27))),
          timezone: 2 * 3600,
          startLocation: "Ensenada de San Miguel",
          endLocation: "Fondeadero del morron",
          skipper: 1,
          crew: [1, 2],
          passengers: [],
          comment: "Nice sailing day with good wind conditions",
          calculated: {
            dayStatusButton: "inmotion",
            dayStatus: "inmotion",
            daysRun: 71.7,
            distance: 19.8,
            distanceUnderEngine: 1.2,
            distanceUnderSails: 18.7,
            duration: parseDuration("6:38"),
            durationCruising: parseDuration("6:38"),
            durationPaused: 0,
            durationUnderEngine: parseDuration("1:20"),
            durationUnderSails: parseDuration("5:49"),
            engines: [
              { number: 1, distance: 2.1, duration: parseDuration("1:20") },
              { number: 2, distance: 1.2, duration: parseDuration("0:46") },
            ],
            sog: 3.0,
            sunrise: new Date(Date.UTC(2025, 5, 27, 4, 22)).toISOString(),
            sunset: new Date(Date.UTC(2025, 5, 27, 19, 12)).toISOString(),
          },
        },

        { id: 7, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, data: "{}", day: day(new Date(Date.UTC(2025, 5, 28))), timezone: 2, startLocation: "Fondeadero del morron", endLocation: "Ensenada de la Fuente", calculated: { duration: parseDuration("13:22"), sog: 2.2, distance: 28.9 } },
        { id: 8, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, data: "{}", day: day(new Date(Date.UTC(2025, 5, 29))), timezone: 2, startLocation: "Ensenada de la Fuente", endLocation: "Cabo de Palos", calculated: { duration: parseDuration("9:21:38"), sog: 2.8, distance: 26.5 } },
        // this day has a note (Journal) but no log entries -- the #1137 "note on an
        // otherwise blank day" scenario, once the deferred day+note creation completes
        { id: 9, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, data: "{}", day: day(new Date(Date.UTC(2025, 5, 30))), timezone: 2 },

        // no day rows at all for 7/1-7/6 -- #1137's fillDayGaps synthesizes 6 (>5)
        // consecutive blank/gap DayViews here, used by the "with-days" catalog fixture

        { id: 13, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, data: "{}", day: day(new Date(Date.UTC(2025, 6, 7))), timezone: 2, comment: "Arrived at Ibiza", startLocation: "Cabo de Palos", endLocation: "Isla de Tabarca", calculated: { duration: parseDuration("15:35"), sog: 1.3, distance: 21.0 } },

        // this are days for trip 2
        { id: 16, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 2, day: day(new Date(Date.UTC(2025, 6, 8))), timezone: 2, startLocation: "Cala Sa Caixota", endLocation: "Cala Porroig", calculated: { duration: parseDuration("2:40"), sog: 0.1, distance: 0.4 } },
        { id: 17, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 2, day: day(new Date(Date.UTC(2025, 6, 9))), timezone: 2, startLocation: "Cala Porroig", endLocation: "El Pelblet de Torrent", calculated: { duration: parseDuration("11:34"), sog: 1.3, distance: 12.7 } },
        { id: 18, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 2, day: day(new Date(Date.UTC(2025, 6, 10))), timezone: 2, startLocation: "El Pelblet de Torrent", endLocation: "Platja Cala Nova", calculated: { duration: parseDuration("4:46"), sog: 2.7, distance: 12.8 } },
        { id: 19, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 10, tripId: 2, day: day(new Date(Date.UTC(2025, 6, 11))), timezone: 2 },
        { id: 20, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 2, day: day(new Date(Date.UTC(2025, 6, 12))), timezone: 2 },
        { id: 21, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 2, day: day(new Date(Date.UTC(2025, 6, 13))), timezone: 2 },
        { id: 22, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 2, day: day(new Date(Date.UTC(2025, 6, 14))), timezone: 2 },
      ] as IDay[],

      logs: [

        { id: 0, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (11 * 60 * 60) + (33 * 60), timeUtc: (9 * 60 * 60) + (33 * 60), timezone: 2 * 3600, comment: "Start of pause", sog: 0, course: 301, distance: 0.0, engineRpms: [0, 0, 0] },
        { id: 11, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (11 * 60 * 60) + (33 * 60), timeUtc: (9 * 60 * 60) + (33 * 60), timezone: 2 * 3600, comment: "Started engine #1", sog: 0, course: 301, distance: 0.0, engineRpms: [0, 1800, 0] },
        { id: 12, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (11 * 60 * 60) + (39 * 60), timeUtc: (9 * 60 * 60) + (39 * 60), timezone: 2 * 3600, comment: "Anchor up", sog: 0.3, course: 360, distance: 0.0, engineRpms: [0, 1800, 0] },
        { id: 13, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (11 * 60 * 60) + (40 * 60), timeUtc: (9 * 60 * 60) + (40 * 60), timezone: 2 * 3600, comment: "End of pause after 0:07", sog: 0.3, course: 360, distance: 0.0, engineRpms: [0, 1800, 0] },
        { id: 14, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (11 * 60 * 60) + (41 * 60), timeUtc: (9 * 60 * 60) + (41 * 60), timezone: 2 * 3600, comment: "Course change 167°", sog: 0.9, course: 193, distance: 0.1, engineRpms: [0, 1800, 0] },
        { id: 15, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (11 * 60 * 60) + (41 * 60), timeUtc: (9 * 60 * 60) + (41 * 60), timezone: 2 * 3600, comment: "Started engine #2", sog: 0.9, course: 193, distance: 0.1, engineRpms: [0, 1800, 1800] },
        { id: 16, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (11 * 60 * 60) + (43 * 60), timeUtc: (9 * 60 * 60) + (43 * 60), timezone: 2 * 3600, comment: "Course change 62°", sog: 1.7, course: 131, distance: 0.1, engineRpms: [0, 1800, 1800] },
        { id: 17, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (11 * 60 * 60) + (44 * 60), timeUtc: (9 * 60 * 60) + (44 * 60), timezone: 2 * 3600, comment: "Mainsail + Parasailor up", sog: 2.0, course: 132, distance: 0.1, engineRpms: [0, 1800, 1800] },
        { id: 18, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (11 * 60 * 60) + (45 * 60), timeUtc: (9 * 60 * 60) + (45 * 60), timezone: 2 * 3600, comment: "Stopped engine #2 after 0:04 (0.1 nm)", sog: 2.3, course: 118, distance: 0.2, engineRpms: [0, 1800, 0] },
        { id: 19, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (11 * 60 * 60) + (55 * 60), timeUtc: (9 * 60 * 60) + (55 * 60), timezone: 2 * 3600, comment: "Started engine #2", sog: 2.2, course: 143, distance: 0.5, engineRpms: [0, 1800, 1800] },
        { id: 20, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (11 * 60 * 60) + (57 * 60), timeUtc: (9 * 60 * 60) + (57 * 60), timezone: 2 * 3600, comment: "Stopped engine #2 after 0:02 (0.1 nm)", sog: 2.7, course: 142, distance: 0.6, engineRpms: [0, 1800, 0] },
        { id: 21, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (12 * 60 * 60), timeUtc: (10 * 60 * 60), timezone: 2 * 3600, comment: "Automatic entry after 1:00", sog: 2.9, course: 128, distance: 0.8, engineRpms: [0, 1800, 0] },
        { id: 22, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (12 * 60 * 60) + (7 * 60), timeUtc: (10 * 60 * 60) + (7 * 60), timezone: 2 * 3600, comment: "Stopped engine #1 after 0:34 (1.0 nm)", sog: 1.5, course: 119, distance: 1.0, engineRpms: [0, 0, 0] },

        { id: 23, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (13 * 60 * 60), timeUtc: (11 * 60 * 60), timezone: 2 * 3600, comment: "Automatic entry after 1:00", sog: 2.8, stw: 2.5, course: 75, heading: 40, distance: 3.5, lat: 36.852, lng: -1.952, depth: 25.1, log: 25812, engineRpms: [0, 0, 0], windDirection: 203, windSpeed: 10, pressure: 1015.1, weather: ILogWeather.clearSky, temperature: 24, seaState: "calm" },

        { id: 24, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (14 * 60 * 60), timeUtc: (12 * 60 * 60), timezone: 2 * 3600, comment: "Automatic entry after 1:00", sog: 3.2, course: 86, distance: 6.8, engineRpms: [0, 0, 0] },
        { id: 25, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (15 * 60 * 60), timeUtc: (13 * 60 * 60), timezone: 2 * 3600, comment: "Automatic entry after 1:00", sog: 2.9, course: 88, distance: 9.7, engineRpms: [0, 0, 0] },
        { id: 26, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (16 * 60 * 60), timeUtc: (14 * 60 * 60), timezone: 2 * 3600, comment: "Automatic entry after 1:00", sog: 2.7, course: 84, distance: 12.4, engineRpms: [0, 0, 0] },
        { id: 27, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (17 * 60 * 60), timeUtc: (15 * 60 * 60), timezone: 2 * 3600, comment: "Automatic entry after 1:00", sog: 3.9, course: 84, distance: 16.4, engineRpms: [0, 0, 0] },
        { id: 28, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (17 * 60 * 60) + (35 * 60), timeUtc: (15 * 60 * 60) + (35 * 60), timezone: 2 * 3600, comment: "Started engine #1", sog: 4.1, course: 53, distance: 18.7, engineRpms: [0, 1800, 0] },
        { id: 29, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (17 * 60 * 60) + (35 * 60), timeUtc: (15 * 60 * 60) + (35 * 60), timezone: 2 * 3600, comment: "Started engine #2", sog: 4.1, course: 53, distance: 18.7, engineRpms: [0, 1800, 1800] },
        { id: 30, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (17 * 60 * 60) + (35 * 60), timeUtc: (15 * 60 * 60) + (35 * 60), timezone: 2 * 3600, comment: "Mainsail + Parasailor down", sog: 4.1, course: 53, distance: 18.7, engineRpms: [0, 1800, 1800] },
        { id: 31, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (17 * 60 * 60) + (45 * 60), timeUtc: (15 * 60 * 60) + (45 * 60), timezone: 2 * 3600, comment: "Course change 59°", sog: 3.6, course: 353, distance: 19.3, engineRpms: [0, 1800, 1800] },
        { id: 32, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (17 * 60 * 60) + (49 * 60), timeUtc: (15 * 60 * 60) + (49 * 60), timezone: 2 * 3600, comment: "Course change 66°", sog: 2.3, course: 287, distance: 19.4, engineRpms: [0, 1800, 1800] },
        { id: 33, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (18 * 60 * 60), timeUtc: (16 * 60 * 60), timezone: 2 * 3600, comment: "Automatic entry after 1:00", sog: 1.6, course: 59, distance: 19.7, engineRpms: [0, 1800, 1800] },
        { id: 34, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (18 * 60 * 60) + (5 * 60), timeUtc: (16 * 60 * 60) + (5 * 60), timezone: 2 * 3600, comment: "Anchor down at Fondeadero del morron", sog: 0.8, course: 329, distance: 19.8, engineRpms: [0, 1800, 1800] },
        { id: 35, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (18 * 60 * 60) + (9 * 60), timeUtc: (16 * 60 * 60) + (9 * 60), timezone: 2 * 3600, comment: "Start of pause", sog: 0.4, course: 212, distance: 19.8, engineRpms: [0, 1800, 1800] },
        { id: 36, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (18 * 60 * 60) + (11 * 60), timeUtc: (16 * 60 * 60) + (11 * 60), timezone: 2 * 3600, comment: "Stopped engine #1 after 0:46 (1.1 nm)", sog: 0.1, course: 261, distance: 19.8, engineRpms: [0, 0, 1800] },
        { id: 37, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, time: (18 * 60 * 60) + (11 * 60), timeUtc: (16 * 60 * 60) + (11 * 60), timezone: 2 * 3600, comment: "Stopped engine #2 after 0:46 (1.1 nm)", sog: 0.1, course: 261, distance: 19.8, engineRpms: [0, 0, 0] },

      ],
      statuses: [
        // Day 6 statuses - anchored overnight before departure
        { id: 1, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, startLogId: 0, endLogId: 13, statusType: IStatusType.ship, value: IShipStatus.anchor, data: JSON.stringify({ location: "Ensenada de San Miguel" }) },

        // In motion during the day
        { id: 2, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, startLogId: 13, endLogId: 35, statusType: IStatusType.ship, value: IShipStatus.inmotion, data: "{}" },

        // At anchor overnight after arrival
        { id: 3, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, startLogId: 35, statusType: IStatusType.ship, value: IShipStatus.anchor, data: JSON.stringify({ location: "Fondeadero del morron" }) },

        // Sails - Mainsail and Parasailor up from log 17 to 30
        { id: 4, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, startLogId: 17, endLogId: 30, statusType: IStatusType.sails, name: "mainsail", value: 0, data: "{}" },
        { id: 5, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, tripId: 1, dayId: 6, startLogId: 17, endLogId: 30, statusType: IStatusType.sails, name: "parasailor", value: 0, data: "{}" },
      ],

      trips: [

        // this trip is used for data
        {
          id: 1,
          createdAt: d,
          updatedAt: d,
          accountId: 1,
          shipId: 1,
          cruiseId: 9,
          title: "Andalusia to Ibiza",
          data: "{}",
          startedAt: new Date(Date.UTC(2025, 5, 24)).toISOString(),
          completedAt: new Date(Date.UTC(2025, 6, 7)).toISOString(),
          timezone: 2 * 3600,
          calculated: {
            daysLogbook: 9,
            daysTotal: 14,
            distance: 203.8,
            distanceUnderEngine: 26.7,
            distanceUnderSails: 177.1,
            duration: parseDuration("111:29"),
            durationCruising: parseDuration("110:25"),
            durationPaused: parseDuration("1:04"),
            durationUnderEngine: parseDuration("11:33"),
            durationUnderSails: parseDuration("98:52"),
            engines: [
              { number: 1, distance: 23.5, duration: parseDuration("9:59") },
              { number: 2, distance: 26.7, duration: parseDuration("11:25") },
            ],
            sog: 2.11,
            startLocation: "Malaga",
            endLocation: "Cala Sa Caixota",
          },
        },

        { id: 2,
          createdAt: d,
          updatedAt: d,
          accountId: 1,
          shipId: 1,
          cruiseId: 9,
          title: "Ibiza to Marseille",
          startedAt: new Date(Date.UTC(2025, 6, 8)).toISOString(),
          completedAt: new Date(Date.UTC(2025, 7, 21)).toISOString(),
          timezone: 2 * 3600,
          calculated: {
            endLocation: "Pointe de Figuerolles",
            startLocation: "Cala Sa Caixota",
          },
        },

        { id: 103, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, title: "Marseille", startedAt: new Date(Date.UTC(2025, 7, 22)).toISOString(), completedAt: new Date(Date.UTC(2025, 7, 27)).toISOString(), timezone: 2 * 3600, endLocation: "near Marseille", startLocation: "Pointe de Figuerolles" },
        { id: 104, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, title: "Marseille to Illetas", startedAt: new Date(Date.UTC(2025, 7, 28)).toISOString(), completedAt: new Date(Date.UTC(2025, 8, 6)).toISOString(), timezone: 2 * 3600, endLocation: "Illetas", startLocation: "near Marseille" },
        { id: 105, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, title: "Illetas to Formentera", startedAt: new Date(Date.UTC(2025, 8, 9)).toISOString(), completedAt: new Date(Date.UTC(2025, 8, 20)).toISOString(), timezone: 2 * 3600, endLocation: "Formentera", startLocation: "Illetas" },
        { id: 106, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, title: "Formentera to Alicante", startedAt: new Date(Date.UTC(2025, 8, 22)).toISOString(), completedAt: new Date(Date.UTC(2025, 8, 24)).toISOString(), timezone: 2 * 3600, endLocation: "Alcante", startLocation: "Formentera" },
        { id: 107, createdAt: d, updatedAt: d, accountId: 1, shipId: 1, cruiseId: 9, title: "Alicante to La Puebla del Rio", startedAt: new Date(Date.UTC(2025, 8, 25)).toISOString(), completedAt: new Date(Date.UTC(2025, 9, 16)).toISOString(), timezone: 2 * 3600, endLocation: "La Puebla del Rio", startLocation: "Alicante" },
      ] as ITrip[],

      notes: [
        {
          id: 1,
          dayId: 6,
          accountId: 1,
          shipId: 1,
          cruiseId: 9,
          tripId: 1,
          createdAt: d,
          updatedAt: d,
          data: "{}",
          noteType: INoteType.journal,
          title: "Perfect Sailing to Fondeadero del morron",
          note: "What an amazing day on the water! We left Ensenada de San Miguel early in the morning with a steady 15-knot breeze from the northeast. The conditions were perfect for sailing.\rWe had the mainsail and parasailor up for most of the journey, making excellent progress. Only needed to run the engine briefly for few minutes when leaving the anchorage. The sea state was calm with gentle 1-meter swells, and visibility was excellent all day.",
          date: new Date(Date.UTC(2025, 5, 27)).toISOString(),
        },

        // #1137 -- a note on a day with no log entries at all (day 9 has no logs/route),
        // the deferred day+note creation scenario for the "with-days" catalog fixture
        {
          id: 2,
          dayId: 9,
          accountId: 1,
          shipId: 1,
          cruiseId: 9,
          tripId: 1,
          createdAt: d,
          updatedAt: d,
          data: "{}",
          noteType: INoteType.journal,
          title: "Resting at anchor",
          note: "Stayed at anchor all day to wait out the forecasted swell -- no need to log a passage today, so no route or log entries, just this note.",
          date: new Date(Date.UTC(2025, 5, 30)).toISOString(),
        },
      ],

      attachments: [
        {
          id: 1,
          noteId: 1,
          accountId: 1,
          shipId: 1,
          createdAt: d,
          updatedAt: d,
          data: "{}",
          fileName: "dolphins-bow-wave",
          fileType: "jpg",
          contentType: "image/jpeg",
          checksum: "abc123",
          size: 245680,
          useUrl: true,
          url: "/demo/dolphins.jpg",
        },
        {
          id: 2,
          noteId: 1,
          accountId: 1,
          shipId: 1,
          createdAt: d,
          updatedAt: d,
          data: "{}",
          fileName: "sunset-anchorage",
          fileType: "jpg",
          contentType: "image/jpeg",
          checksum: "def456",
          size: 312450,
          useUrl: true,
          url: "/demo/sunset.jpg",
        },
      ],

    });
  }
  return data;
};
